import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock, FileText, Database, Shield, Clock3, ImageIcon, Scale } from 'lucide-react';
import { Button, Section } from './Shared';
import { trackFb } from '../lib/fbpixel';
export function Hero() {
  const scrollToPricing = () => {
    trackFb('AddToCart', {
      content_name: 'Colección NOS MIENTEN',
      currency: 'ARS',
      value: 27990
    });
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-10 md:pt-20 md:pb-14 px-5 overflow-hidden" data-id="element-156">
      {/* Background effects */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-brand-anthracite via-brand-dark to-brand-dark -z-10" data-id="element-157" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand-gold/5 blur-[120px] rounded-full -z-10" data-id="element-158" />

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-160">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-brand-red/30 bg-brand-red/10 text-brand-red text-xs font-bold tracking-widest uppercase mb-6" data-id="element-161">
            <Lock className="w-3 h-3" data-id="element-162" />
            <span data-id="element-163">Acceso Clasificado</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-164">
            El libro que nunca quisieron que leyeras.
          </h1>

          <div className="text-base md:text-xl text-brand-muted max-w-3xl mx-auto mb-10 leading-relaxed space-y-3" data-id="element-165">
            <p data-id="element-166">
              Durante más de 80 años, documentos, testimonios, casos militares y
              archivos fueron apareciendo de forma aislada.
            </p>
            <p data-id="element-167">Algunos fueron ignorados.</p>
            <p data-id="element-168">Otros ridiculizados.</p>
            <p data-id="element-169">Muchos simplemente quedaron olvidados.</p>
            <p className="text-brand-offWhite" data-id="element-170">
              NOS MIENTEN reúne esas piezas en una única investigación
              documental para mostrar una historia que rara vez se cuenta
              completa.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full max-w-4xl mx-auto mb-12" data-id="element-171">
          <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-transparent to-transparent z-10 h-full" data-id="element-172" />
          <img src="https://cdn.magicpatterns.com/uploads/g9b2hwXCqjNA6SvEzeo6ts/ChatGPT_Image_26_jun_2026,_18_39_00.png" alt="Portada de NOS MIENTEN, investigación documental" className="w-full h-auto object-cover rounded-lg shadow-2xl relative z-0" data-id="element-173" />
          <p className="relative z-20 max-w-xl mx-auto mt-4 px-4 text-center text-xs md:text-sm text-brand-gold leading-relaxed" data-id="element-174">
            Una investigación documental basada en décadas de casos, testimonios
            y documentos históricos.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="w-full max-w-md mx-auto" data-id="element-175">
          <ul className="text-left space-y-3 mb-8 bg-brand-card/50 p-6 rounded-xl border border-brand-anthracite" data-id="element-176">
            {['Más de 300 páginas de investigación documental.', 'Casos militares, documentos y testimonios históricos.', 'Organizado en 6 tomos para una lectura clara y progresiva.', 'Formato digital para leer cuando y donde quieras.'].map((bullet, idx) => <li key={idx} className="flex items-center gap-3 text-sm md:text-base text-brand-offWhite" data-id="element-177">
                <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-178" />
                <span data-id="element-179">{bullet}</span>
              </li>)}
          </ul>

          <Button fullWidth onClick={scrollToPricing} className="text-lg py-5" data-id="element-180">
            QUIERO LEER EL LIBRO
          </Button>
          <p className="text-xs text-brand-muted mt-4 text-center" data-id="element-181">
            Acceso inmediato • Formato digital • Investigaciones incluidas
          </p>
        </motion.div>
      </div>
    </section>;
}
const archiveContents = [{
  icon: Shield,
  title: 'Casos militares',
  desc: 'Conocé algunos de los incidentes documentados más impactantes protagonizados por pilotos, radares y fuerzas armadas.'
}, {
  icon: FileText,
  title: 'Documentos desclasificados',
  desc: 'Descubrí informes publicados que permanecieron reservados durante años y hoy forman parte del debate público.'
}, {
  icon: ImageIcon,
  title: 'Grandes enigmas',
  desc: 'Investigaciones que siguen generando preguntas décadas después de haber sido registradas.'
}, {
  icon: Clock3,
  title: 'Cronologías que conectan',
  desc: 'Seguí los hechos en orden para entender cómo se relacionan casos que suelen aparecer aislados.'
}, {
  icon: Database,
  title: 'Testimonios históricos',
  desc: 'Recorré declaraciones y relatos que ayudan a reconstruir el contexto de cada investigación.'
}, {
  icon: Scale,
  title: 'Hipótesis comparadas',
  desc: 'Observá distintas lecturas de la evidencia sin respuestas prefabricadas.'
}];
export function ArchiveContents() {
  return <Section darker data-id="element-182">
      <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-183">
        <h2 className="text-2xl md:text-4xl font-bold text-white" data-id="element-184">
          ¿Qué vas a encontrar dentro?
        </h2>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4" data-id="element-185">
        {archiveContents.map(item => <article key={item.title} className="bg-brand-anthracite border border-brand-card rounded-xl p-5" data-id="element-186">
            <item.icon className="w-5 h-5 text-brand-gold mb-4" data-id="element-187" />
            <h3 className="text-base font-bold text-white mb-2" data-id="element-188">
              {item.title}
            </h3>
            <p className="text-sm text-brand-muted leading-relaxed" data-id="element-189">
              {item.desc}
            </p>
          </article>)}
      </div>
    </Section>;
}
export function Tension() {
  return <Section data-id="element-190">
      <div className="text-center max-w-3xl mx-auto" data-id="element-191">
        <p className="text-xs font-bold tracking-[0.18em] text-brand-gold uppercase mb-3" data-id="element-192">
          Antes de abrir este libro...
        </p>
        <div className="space-y-5 text-brand-muted text-base md:text-lg leading-relaxed" data-id="element-193">
          <p data-id="element-194">Durante décadas conocimos fragmentos de historias.</p>
          <div className="font-serif text-xl md:text-2xl text-white space-y-1" data-id="element-195">
            <p data-id="element-196">Roswell.</p>
            <p data-id="element-197">Área 51.</p>
            <p data-id="element-198">Pilotos militares.</p>
            <p data-id="element-199">Objetos voladores no identificados.</p>
            <p data-id="element-200">Civilizaciones perdidas.</p>
          </div>
          <p data-id="element-201">Pero casi siempre nos mostraron cada caso por separado.</p>
          <p className="text-brand-offWhite" data-id="element-202">
            Este libro hace exactamente lo contrario.
          </p>
          <p data-id="element-203">
            Conecta documentos, investigaciones y testimonios para que puedas
            entender el contexto completo.
          </p>
          <div className="text-white font-medium text-lg md:text-xl border-l-2 border-brand-gold pl-4 text-left space-y-1" data-id="element-204">
            <p data-id="element-205">No intenta convencerte.</p>
            <p data-id="element-206">Te entrega la información.</p>
            <p data-id="element-207">Las conclusiones son tuyas.</p>
          </div>
        </div>
      </div>
    </Section>;
}
export function WhatThisIs() {
  return <Section data-id="element-208">
      <div className="max-w-2xl mx-auto text-center" data-id="element-209">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-6" data-id="element-210">
          Esto no es un ebook que vas a leer una vez.
        </h2>
        <div className="text-brand-muted mb-8 text-base md:text-lg space-y-4" data-id="element-211">
          <p data-id="element-212">
            Es una obra documental creada para volver a ella una y otra vez.
          </p>
          <p data-id="element-213">
            Cada tomo desarrolla una parte distinta de la investigación y fue
            organizado para ayudarte a comprender cómo se relacionan casos que
            normalmente aparecen aislados.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4 max-w-md mx-auto" data-id="element-214">
          {[{
          icon: FileText,
          text: 'Investigación documental'
        }, {
          icon: Database,
          text: 'Información organizada'
        }, {
          icon: ImageIcon,
          text: 'Archivo visual'
        }, {
          icon: CheckCircle2,
          text: 'Obra de consulta'
        }].map((item, idx) => <div key={idx} className="flex items-center gap-2 text-sm text-brand-offWhite bg-brand-dark p-3 rounded-lg border border-brand-card" data-id="element-215">
              <item.icon className="w-4 h-4 text-brand-gold" data-id="element-216" />
              <span data-id="element-217">{item.text}</span>
            </div>)}
        </div>
      </div>
    </Section>;
}
export function MainCollection() {
  return <Section darker className="text-center" data-id="element-218">
      <h2 className="text-xs font-bold tracking-widest text-brand-gold uppercase mb-3" data-id="element-219">
        La investigación central
      </h2>
      <h3 className="text-2xl md:text-4xl font-bold text-white mb-8" data-id="element-220">
        Un libro construido para ser consultado
      </h3>

      <div className="bg-brand-anthracite border border-brand-card rounded-2xl p-6 md:p-10 max-w-4xl mx-auto text-left relative overflow-hidden" data-id="element-221">
        <div className="absolute top-0 right-0 w-64 h-64 bg-brand-gold/5 blur-3xl rounded-full" data-id="element-222" />

        <div className="flex flex-col md:flex-row gap-8 items-center relative z-10" data-id="element-223">
          <div className="w-full md:w-1/3" data-id="element-224">
            <img src="https://cdn.magicpatterns.com/uploads/g9b2hwXCqjNA6SvEzeo6ts/ChatGPT_Image_26_jun_2026,_18_39_00.png" alt="Nos Mienten Cover" className="w-full h-auto rounded shadow-xl object-cover object-left h-[300px]" data-id="element-225" />
          </div>
          <div className="w-full md:w-2/3" data-id="element-226">
            <h4 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-227">
              NOS MIENTEN: El Archivo de los No Contactados
            </h4>
            <p className="text-brand-gold text-sm font-medium mb-4" data-id="element-228">
              LA INVESTIGACIÓN DOCUMENTAL CENTRAL
            </p>
            <p className="text-brand-muted text-base leading-relaxed" data-id="element-229">
              Un libro documental dividido en 6 tomos para recorrer casos,
              fuentes, testimonios y debates desde sus primeros registros hasta
              el presente. Una obra de consulta que organiza material disperso
              para que cada lector pueda explorar el contexto y formar sus
              propias conclusiones.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}